<template>
  <div class="task-batch-status" :title="displayStatus">
    <div class="task-batch-status__row">
      <span class="task-batch-status__label">Status:</span>
      <span class="task-batch-status__state">{{ displayStatus }}</span>
    </div>
    <div class="task-batch-status__id">{{ displayProcessId }}</div>
    <img v-if="showStatusIcon" :src="statusIcon" class="task-batch-status__icon" alt="status icon">
  </div>
</template>

<script setup>
import { computed } from 'vue';
import checkIcon from '@/assets/img/svg/check-button.svg';
import failedIcon from '@/assets/img/svg/failed.svg';
import questionIcon from '@/assets/img/svg/question.svg';
import personIcon from '@/assets/img/svg/person.svg';
import runningIcon from '@/assets/img/animated/running.gif';
import hourglassIcon from '@/assets/img/animated/hourglass.gif';

const props = defineProps({
  process_info: {
    type: Object,
    default: () => ({
      id: '',
      status: '',
    }),
  },
});

const normalizedState = computed(() => (props.process_info?.status || '').trim().toLowerCase());
const displayStatus = computed(() => {
  const manageType = String(props.process_info?.manage_type || '').trim().toLowerCase();
  if (manageType === 'user') {
    return 'User Managed';
  }

  return props.process_info?.status || 'Unknown';
});
const normalizedDisplayStatus = computed(() => String(displayStatus.value || '').trim().toLowerCase());
const showStatusIcon = computed(() => normalizedState.value !== '');
const displayProcessId = computed(() => {
  const processId = String(props.process_info?.id || '').trim();
  return processId ? processId : 'No Server Process';
});

const statusIcon = computed(() => {
  if (!showStatusIcon.value) {
    return null;
  }

  if (normalizedDisplayStatus.value.includes('user')) {
    return personIcon;
  }

  if (!normalizedState.value || normalizedState.value === 'unknown') {
    return questionIcon;
  }

  if (normalizedState.value === 'succeeded' || normalizedState.value === 'terminated' || normalizedState.value === 'complete') {
    return checkIcon;
  }

  if (normalizedState.value === 'failed' || normalizedState.value === 'stopped' || normalizedState.value === 'error') {
    return failedIcon;
  }

  if (normalizedState.value === 'running') {
    return runningIcon;
  }

  return hourglassIcon;
});
</script>

<style scoped lang="scss">
.task-batch-status {
  padding: 6px 8px;
  height: fit-content;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  column-gap: 8px;
  row-gap: 4px;
  width: 100%;
}

.task-batch-status__row {
  display: flex;
  align-items: center;
  gap: 6px;
  grid-column: 1;
  grid-row: 1;
}

.task-batch-status__label {
  font-size: 11px;
  color: var(--body-text-color-secondary, #666);
  font-weight: 600;
}

.task-batch-status__state {
  font-size: 11px;
  color: var(--body-text-color, #222);
  font-weight: 600;
}

.task-batch-status__icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  grid-column: 2;
  grid-row: 1 / 3;
  align-self: center;
  justify-self: end;
}

.task-batch-status__id {
  font-size: 9px;
  line-height: 1;
  color: var(--body-text-color-secondary, #888);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  grid-column: 1;
  grid-row: 2;
}
</style>
